import { useTranslations } from '@aikoa/i18n/react'
import { useGlobalSearchParams } from 'expo-router'
import { ConvertPropertyFlow } from '~/components/assets/ConvertPropertyFlow'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { SectionContent, SectionTitle } from '~/components/layout/Sections'
import { LoadingView } from '~/components/LoadingView'
import { useAsset } from '~/data/assets/useAssets'

export default function ConvertPropertyIndex() {
  return (
    <ScreenView>
      <ConvertPropertyContent />
    </ScreenView>
  )
}

function ConvertPropertyContent() {
  const { t } = useTranslations('property')
  const { assetId } = useGlobalSearchParams<{ assetId: string }>()
  const { asset, isLoading: isAssetLoading } = useAsset(assetId)

  if (isAssetLoading) {
    return <LoadingView />
  }

  if (!asset || !asset.relations.some((r) => r.relation_type === 'representation')) {
    return (
      <ContentBox>
        <SectionTitle className="pb-4">{t(($) => $.errors.notFoundConvert)}</SectionTitle>
        <SectionContent>{t(($) => $.errors.notFoundConvertDescription)}</SectionContent>
      </ContentBox>
    )
  }

  return <ConvertPropertyFlow asset={asset} />
}
